<template>
    <div>
        <VuePerfectScrollbar class="scroll-area" :settings="psSettings" @ps-y-reach-end="scrollHandle">
          <div class="mr-5">
            <div class="border-0">
              <div>
                <main class="inbox border-0 padding-0" v-if="!isQuestionnaire()">
                  <TemplateItem :extensible="extensible"
                      @template-send-as-sms="handleSendAsSMS"
                      @deleted-extensible="handleDeleted"/>
                </main>
                <main v-else>
                  <QuestionnaireView :extensible="extensible"
                      @template-send-as-sms="handleSendAsSMS"
                      @deleted-extensible="handleDeleted"
                      @reloaded-questionnaire="handleReloadedQuestionnaire"/>
                </main>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions } from "vuex"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import TemplateItem from './TemplateItem'
import QuestionnaireView from './QuestionnaireView'

export default {
  name: 'ExtensibleView',
  components: {
    VuePerfectScrollbar,
    TemplateItem,
    QuestionnaireView,
  },
  props: {
    extensible: {
      type: Object,
      default: null
    },
    type: String,
  },
  computed: {
    ...mapState('user', ['user']),
    psSettings: () => {
      return {
        maxScrollbarLength: 60,
        minScrollbarLength: 40,
        suppressScrollX: getComputedStyle(document.querySelector('html')).direction !== 'rtl',
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 })
      }
    }
  },
  methods: {
    scrollHandle (evt) {
      this.$emit(`load-more-templates`)
    },
    isQuestionnaire: function() {
        let questionnaireType = true
        switch (this.type) {
            case 'text':
            case 'image':
            case 'audio':
            case 'video':  
                 questionnaireType = false
                break;
        }

        return questionnaireType
    },
    handleSendAsSMS: function(content) {
      this.$emit('template-send-as-sms', content)
    },
    handleDeleted: function() {
      this.$emit('deleted-extensible')
    },
    handleReloadedQuestionnaire: function(questionnaire) {
        this.$emit('reloaded-questionnaire', questionnaire)
    }
  },
}
</script>

<style lang="css" scoped>
  .content-border {
    border: 1px #edebe9 solid;
  }
  
  .scroll-area {
    position: relative;
    height: calc(100vh - 18vh);
  }
</style>

